import React from "react";
import { Slider as DebtSlider } from "@mui/material";

const Index = ({
  handleSliderChange,
  setFormError,
  debtValue,
  formError,
  setStep,
  values,
  step,
}) => {
  const boxShadow =
    "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)";
  const formatNumber = (text) => {
    return text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="w-auto justify-center items-center">
      {" "}
      <p className="text-white text-center text-lg font-bold mb-4">
        Choose the debt amount you owe
      </p>
      <h2 className="text-white text-center text-6xl md:text-7xl font-bold my-4">
        ${formatNumber(debtValue)}
      </h2>
      <DebtSlider
        defaultValue={35000}
        min={8000}
        max={200000}
        step={1000}
        onChange={handleSliderChange}
        sx={{
          fontSize: "1.0rem",
          color: "rgba(27, 151, 106, 0.64)",
          "& .MuiSlider-thumb": {
            color: "white",
            height: 30,
            width: 30,
            boxShadow: boxShadow,
            "&:focus, &:hover, &.Mui-active": {
              boxShadow:
                "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)",
              // Reset on touch devices, it doesn't add specificity
              "@media (hover: none)": {
                boxShadow: boxShadow,
              },
            },
          },
          "& .MuiSlider-track": {
            height: 12,
            backgroundColor: "orange",
            border: "none",
          },
          "& .MuiSlider-rail": {
            height: 12,
            backgroundColor: "orange",
            border: "none",
          },
        }}
      />
      {formError.option3 ? (
        <p className="w-full flex justify-center items-center my-4 text-lg font-semibold text-red-700">
          {formError.option3}
        </p>
      ) : null}
      <div className="w-full flex justify-center items-center mt-4 gap-4">
        <button
          className="bg-white text-[#2C6BB3] font-bold px-8 text-[23.48px] rounded-md"
          onClick={() => {
            if (values.option3) {
              if (step < 4) setStep(step + 1);
            } else {
              setFormError({
                ...formError,
                option3: "Please select a debt amount.",
              });
            }
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default Index;
